/*
 * @Author: yuanjianlong
 * @Description:
 * @Date: 2021-08-30 14:31:56
 * @LastEditTime: 2023-11-02 13:58:15
 * @FilePath: /teacher-h5/src/config/outsideUrl.js
 */
// 引用外部url
exports.url = {
  // 用户协议
  userProtocol: 'https://fe-sta.aixuexi.com/axx-teaching/app-resource/jzx/user-protocol.html',
  // 私权政策
  privacyPolicy: 'https://fe-sta.aixuexi.com/axx-teaching/app-resource/jzx/privacy-policy.html',
  // jzxTeacher: 'https://test.aixuexi.com:8989/teacherv2'
  jzxTeacher: 'https://jzx.aixuexi.com/teacherv2'
}

// 小括狐学习报告地址
exports.getReportUrl = function ({ userId, classTypeId, lessonId, checkSign, outputSource }) {
  return `https://c.aixuexi.com/partner-h5/#/study-lesson-report-pad?userId=${userId}&classTypeId=${classTypeId}&lessonId=${lessonId}&checkSign=${checkSign}&outputSource=${outputSource}`
}